import QueryString from 'qs'

const BASE_URL = 'ai-service/api/unique-ai-objects'

export function _getUniqueAiObject({ uniqueAIObjectId }) {
  return {
    url: `${BASE_URL}/${uniqueAIObjectId}`,
    method: 'get',
  }
}

const uniqueAIObjectsRequests = {
  getUniqueAiObjectsRequest: ({ aiObjectId, contentId }) => ({
    url: `${BASE_URL}/${aiObjectId}/${contentId}`,
    method: 'get',
  }),
  searchUniqueAiObjectsRequest: ({ uniqueAIObjectId, contentId, type, searchText, isParent, skip = 0, take = 50 }) => ({
    url: `${BASE_URL}/${uniqueAIObjectId}/${contentId}/connection/search`,
    method: 'get',
    params: {
      type,
      search: searchText,
      isParent,
      skip,
      take,
    },
    paramsSerializer: (params) => QueryString.stringify(params, { arrayFormat: 'repeat' }),
  }),
  addUniqueAiObjectRequest: (data) => ({
    url: BASE_URL,
    method: 'post',
    data,
  }),
  shallowCloneUniqueAiObjectRequest: (data) => ({
    url: `${BASE_URL}/shallow-clone`,
    method: 'post',
    data,
  }),
  getUniqueAiObjectRequest: _getUniqueAiObject,
  getUniqueAiObjectForEditRequest: _getUniqueAiObject,
  updateUniqueAiObjectRequest: (data) => ({
    url: BASE_URL,
    method: 'put',
    data,
  }),
  deleteUniqueAiObjectRequest: ({ contentId, uniqueAIObjectId }) => ({
    url: `${BASE_URL}/${uniqueAIObjectId}`,
    method: 'delete',
    params: {
      contentId,
    },
  }),
  addUniqueAiObjectConnectionRequest: (data) => ({
    url: `${BASE_URL}/connection`,
    method: 'post',
    data,
  }),
  deleteUniqueAiObjectConnectionRequest: ({ uniqueAIObjectConnectionId }) => ({
    url: `${BASE_URL}/connection/${uniqueAIObjectConnectionId}`,
    method: 'delete',
  }),
  autofillPageUniqueAiObjectsRequest: (data) => ({
    url: `${BASE_URL}/autofill`,
    method: 'put',
    data,
  }),
  getUniqueAiObjectsByAnnotationIdsRequest: ({ annotationIds }) => ({
    url: `${BASE_URL}/get-by-annotation-ids`,
    method: 'post',
    data: { annotationIds },
  }),
  getUniqueAiObjectsByIdsRequest: ({ uniqueAIObjectIds }) => ({
    url: `${BASE_URL}/get-by-ids`,
    method: 'post',
    data: { uniqueAIObjectIds },
  }),
}

export default uniqueAIObjectsRequests
